import $ from 'jquery';
import mousewheel from 'jquery-mousewheel';
mousewheel($);

$(document).ready(() => {
  
})